var _defs, _g;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgGoogle = function SvgGoogle(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#7d1dd1;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M65.191,5.773a4.513,4.513,0,0,1,6.79-.466l.352.352L75.15,2.842,74.8,2.49a8.5,8.5,0,0,0-12.021,0q-.219.219-.419.45Z",
    transform: "translate(-60.288 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M247.058,205.7q.231-.2.45-.419a8.444,8.444,0,0,0,2.49-6.01,8.574,8.574,0,0,0-.139-1.54l-.075-.408H241v3.984h4.531a4.5,4.5,0,0,1-1.3,1.564Z",
    transform: "translate(-232.998 -190.772)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M70.634,339.535a4.522,4.522,0,0,1-5.443-1.4l-2.833,2.833q.2.231.419.45a8.5,8.5,0,0,0,10.774,1.031Z",
    transform: "translate(-60.288 -326.911)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M4.378,119.129a4.512,4.512,0,0,1,0-3.688l-2.92-2.92a8.511,8.511,0,0,0,0,9.528Z",
    transform: "translate(0 -108.785)"
  }))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgGoogle, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/google.7e7d61c2.svg";
export { ForwardRef as ReactComponent };